import Constants from '../Constants';

function getDealerByExperience(): string {
  const DealersExperience = sessionStorage.getItem('dealersExperience');
  switch (DealersExperience) {
    case 'hyundai':
      return Constants.Experiences.Ia.Dealers.Hyundai;
    case 'acura':
      return Constants.Experiences.Ia.Dealers.Acura;
    case 'honda':
      return Constants.Experiences.Ia.Dealers.Honda;
    case 'genesis':
      return Constants.Experiences.Ia.Dealers.Genesis;
    default:
      return Constants.Experiences.Ia.Dealers.UniFi;
  }
}

export function getExperience(): string {
  const experienceContext: { [name: string]: string } = {};
  experienceContext.client_0 = Constants.Experiences.Ia.Clients;
  experienceContext.client_6 = Constants.Experiences.Investia.Clients;
  experienceContext.advisor_0 = Constants.Experiences.Ia.Advisors;
  experienceContext.advisor_6 = Constants.Experiences.Investia.Advisors;
  experienceContext.client_14 = Constants.Experiences.IaPrivateWealth.Clients;
  experienceContext.dealer_0 = getDealerByExperience();
  experienceContext.partner_0 = Constants.Experiences.Ia.Partners;
  const contextKey = `${process.env.REACT_APP_CMS_USER_CONTEXT}_${process.env.REACT_APP_CMS_BUSINESS_ENTITY_CODE}`;

  return experienceContext[contextKey];
}
